import gettext from '@sdk/lang/gettext';

import { ComposeConversationHeaderWithPadding } from '@web/conversations/ComposeConversation/ComposeConversationHeader/ComposeConversationHeader';
import GroupsIcon from '@web/assets/svg/Icons/48/groups-blue.svg';

export const CreateGroupConversationHeader = () => (
  <ComposeConversationHeaderWithPadding>
    <GroupsIcon />
    <div>
      <ComposeConversationHeaderWithPadding.Title>
        {gettext('New group conversation')}
      </ComposeConversationHeaderWithPadding.Title>
      <ComposeConversationHeaderWithPadding.Subtitle>
        {gettext('Message multiple users, or even positions, locations, and groups.')}
      </ComposeConversationHeaderWithPadding.Subtitle>
    </div>
  </ComposeConversationHeaderWithPadding>
);
